"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DeviceType_1 = require("./DeviceType");
const useGetDevice_1 = require("./useGetDevice");
function useGetAppStoreDownloadLink() {
    const device = (0, useGetDevice_1.default)();
    switch (device) {
        case DeviceType_1.default.Android:
            return 'https://play.google.com/store/apps/details?id=com.activision.callofduty.warzone';
        case DeviceType_1.default.iOS:
            return 'https://apps.apple.com/us/app/id1638368439?ign-itscg=as10001&ign-itsct=WZNP_SC02_PT069_US_A_1638368439';
        default:
            return '';
    }
}
exports.default = useGetAppStoreDownloadLink;
